import { useCallback, useContext } from 'react';

import IsTeamFlagEnabledContext from 'components/contexts/is_team_flag_enabled';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

export default function useIsTeamFlagEnabled() {
  const enabledFeatures = useContext(IsTeamFlagEnabledContext);
  const isFeatureEnabled = useIsFeatureEnabled();

  return useCallback(
    flagName => {
      const featureEnabled = isFeatureEnabled(flagName);
      const teamFlagEnabled = (enabledFeatures && enabledFeatures.has(flagName)) || false;
      return featureEnabled && teamFlagEnabled;
    },
    [enabledFeatures, isFeatureEnabled]
  );
}
